import React, { useState } from 'react';
import './VerticalCampaignNavbarResponsive.css';

const NAVBAR_HEIGHT = 56; // 顶部navbar高度

const VerticalCampaignNavbar = ({ selectedId, onSelect, onCollapseChange, campaigns }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // 通知父组件收缩状态
  React.useEffect(() => {
    if (onCollapseChange) onCollapseChange(collapsed);
  }, [collapsed, onCollapseChange]);

  // 移动端切换菜单
  const handleMobileMenu = () => setMobileMenuOpen(v => !v);

  return (
    <nav
      className={`vertical-campaign-navbar-responsive${collapsed ? ' collapsed' : ''}${mobileMenuOpen ? ' mobile-open' : ''}`}
    >
      <div className="navbar-header-row" style={{display: 'flex', alignItems: 'center', width: '100%'}}>
        {collapsed ? (
          <div className="navbar-title-vertical">My Campaign</div>
        ) : (
          <div className="navbar-title">My Campaign</div>
        )}
        <button
          className="mobile-navbar-toggle"
          onClick={handleMobileMenu}
          aria-label="Toggle navigation"
        >
          <span className="hamburger-icon">☰</span>
        </button>
      </div>
      {!collapsed && (
        <ul className="campaign-list">
          {(Array.isArray(campaigns) ? campaigns : []).map(c => (
            <li
              key={c.id}
              className={selectedId === c.id ? 'active' : ''}
              onClick={() => { onSelect(c.id); setMobileMenuOpen(false); }}
              title={c.name}
            >
              {c.name}
            </li>
          ))}
        </ul>
      )}
      {/* 桌面端收缩按钮 */}
      <button
        className="collapse-btn"
        onClick={() => setCollapsed(v => !v)}
        title={collapsed ? 'Expand' : 'Collapse'}
      >
        <span className="collapse-arrow">❮</span>
      </button>
    </nav>
  );
};

export default VerticalCampaignNavbar; 